import React  from 'react';
const value = {
  path:"stress_test",
  title:"B-20 Stress Test",
  date_modified:"Jan 2020",
  date_created:"Jan 2020",
  content:
[
<p align="justify">
  Another hurdle Canadian buyers must overcome is the “stress test”. The B-20 Stress Test forces banks and other federally regulated lenders (not credit unions) to perform your mortgage qualifying analysis using an interest rate that is higher than the final rate you will be offered. This prevents people who can just barely afford a house from buying; an attempt to add some stability to the housing market. The premise is: since rates will likely rise at sometime over the course of the amortization period, you need to already qualify for a mortgage at the higher rates. Otherwise, when it comes time to renegotiate your terms, you might not be able to afford the mortgage payments that come along with increased rates. There are two different ways this inflated rate is determined. If you are required to buy mortgage default insurance, your adjusted interest rate would be either: the benchmark rate, or the rate negotiated with your lender - whatever is higher. If you do not need mortgage insurance, the adjusted rate used would be either the benchmark rate, or the rate you negotiated plus 2%.
</p>
],
  tags:["mortgage","pre-approval","stress test","government program"]
}

export default value



// WEBPACK FOOTER //
// src/content/stressTest.js